<div class="animated fadeIn">
  <div class="card">

    <div class="card-body" [style]="{'border': '1px solid red!important;'}">

      <div class="row">
        <div class="col-sm-3 col-3">
          

          <p-table #dt [columns]="cols"   [loading]="loading" selectionMode="single" [(selection)]="selectedStaff"
            (onRowSelect)="selectStaff()" [value]="staffs" [scrollable]="true">


            <ng-template pTemplate="caption">
              <div style="text-align: right">

                <span *ngIf='staffs'>

                  {{staffs.length}} USER </span>
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" pInputText placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>

                <th [style]="{'width':'300px'}">
                  <button type="button" *ngIf="false" (click)="createStaff()" class="btn btn-sm btn-warning">
                    <i class="icon-plus"></i> New </button>

                </th>
                <th [style]="{'width':'5px!important'}" data-ng-style="5" *ngFor="let col of cols" [pSortableColumn]="col.field">
                  <p-sortIcon [style]="{'width':'5px!important'}" [field]="col.field"></p-sortIcon>

                </th>
                <th [style]="{'width':'50px'}">
                  <button type="button" (click)="archiverUser()" [disabled]='!selectedStaff' class="btn btn-sm btn-danger">
                    <i class="fa fa-remove"></i>Remove
                  </button>
                </th>
              </tr>

            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData" [ngStyle]="{'background-color': (selectedStaff) &&  (rowData.userId === selectedStaff.userId) ? '#ef8b00' :'white'  }">


                <td>
                  {{rowData.nom}}  
                  <span class="badge "  > {{rowData.roleUser}} </span>
                </td>



              </tr>
            </ng-template>



          </p-table>


        </div>
        <div class="col-sm-9 col-9">
          <div *ngIf='selectedStaff'>


            <div class="row">
              <div class="col-10">
                <div [style.font-size]=" '23px' " [style.color]=" 'red' " *ngIf='!isEdit'>
                  <strong>{{selectedStaff.nom | uppercase}}</strong>
                </div>
                <input *ngIf="isEdit" class="col-9" type="text" class="form-control" [(ngModel)]="selectedStaff.nom" placeholder="Enter staff name">
              </div>
              <div class="col-2">
                <button *ngIf='!isEdit' type="button" (click)="isEdit=true;  " class="btn btn-sm btn-outline-primary">
                  <i class="fa fa-edit"></i> Edit </button>
                <button *ngIf='isEdit' type="button" (click)="isEdit=false;save()" class="btn btn-sm btn-outline-primary">
                  <i class="fa fa-save"></i> Save </button>
                <button *ngIf='isEdit' type="button" (click)="isEdit=false;" class="btn btn-sm btn-outline-danger">
                  <i class="fa fa-remove"></i> Cancel</button>
              </div>
            </div>
            <br />
            <div class="row">


              <div class="col-4">



                <label class="col-3 ">
                  <strong> Titre:</strong>
                </label>
                <input *ngIf="isEdit" class="col-9" type="text" class="form-control" [(ngModel)]="selectedStaff.fonction">
                <span *ngIf="!isEdit" class="col-9">{{selectedStaff.fonction }}</span>

                <br />
                <label class="col-3 ">
                  <strong> Login:</strong>
                </label>
                <input *ngIf="isEdit" class="col-9" type="text" class="form-control" [(ngModel)]="selectedStaff.login">
                <span *ngIf="!isEdit" class="col-9">{{selectedStaff.login }}</span>

                <br />
                <label class="col-3 ">
                  <strong> Password:</strong>
                </label>
                <input type="text"     *ngIf="isEdit" class="col-9"  class="form-control" [(ngModel)]="selectedStaff.password">
                <span *ngIf="false" class="col-9">{{selectedStaff.password}}</span>
                
                <br />
                <label class="col-3 ">
                  <strong> E-MAIL :</strong>
                </label>
                <input *ngIf="isEdit" class="col-9" type="text" class="form-control" [(ngModel)]="selectedStaff.mail">
                <span *ngIf="!isEdit" class="col-9">{{selectedStaff.mail}}</span>
                <br />
                <label class="col-3 ">
                  <strong> Password E-Mail:</strong>
                </label>
                <input type="password" type="text"   *ngIf="isEdit" class="col-9"  class="form-control" [(ngModel)]="selectedStaff.mailpass">
                <span *ngIf="!isEdit" class="col-9">{{selectedStaff.mailpass}}</span>
             
                <br>
                
                <label class="col-3 ">

                  <strong> Commercial:</strong>
                </label>

                <p-checkbox class="col-9" [(ngModel)]="selectedStaff.commercial" binary="true" [disabled]="!isEdit"></p-checkbox>

                <br />


                <label class="col-3 ">
                  <strong> Projet:</strong>
                </label>

                <p-multiSelect id="projet" *ngIf="isEdit" class="col-9" class="form-control" (onChange)="selectProjectPr()" [options]="projets"
                  [(ngModel)]="selectedProject"></p-multiSelect>
                <span *ngIf="!isEdit" class="col-9">{{selectedStaff.projet }}</span>


                <br />
              </div>


              <div  class="col-8">
<h3 style="color: red;" >Roles</h3>
          
        <div class="row">
          
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <div class="ui-g-12"><p-checkbox  [disabled]="!isEdit" name="group1" value="client" label="Clients" [(ngModel)]="selectedRoles" inputId="ny"></p-checkbox></div>
            <div class="ui-g-12"><p-checkbox  [disabled]="!isEdit" name="group1" value="exposant" label="Exposant" [(ngModel)]="selectedRoles" inputId="ny"></p-checkbox></div>
            <div class="ui-g-12"><p-checkbox  [disabled]="!isEdit" name="group1" value="delegue" label="Délégué" [(ngModel)]="selectedRoles" inputId="sf"></p-checkbox></div>
            <div class="ui-g-12"><p-checkbox  [disabled]="!isEdit" name="group1" value="sponsor" label="Sponsor" [(ngModel)]="selectedRoles" inputId="la"></p-checkbox></div>
          </div>


          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
             <div class="ui-g-12"><p-checkbox  [disabled]="!isEdit" name="group1" value="admin" label="Admin" [(ngModel)]="selectedRoles" inputId="la"></p-checkbox></div>
         
       
       
          </div>


          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <div class="ui-g-12"><p-checkbox  [disabled]="!isEdit" name="group1" value="floor" label="Floor Plan" [(ngModel)]="selectedRoles" inputId="ny"></p-checkbox></div>
         
              
          </div>
          <br>
 


        </div>      
        



            
              
              </div>

            </div>

             
            <div class="row">


            
              <div class="col-6">



         
  
                  <br />
                  <label class="col-6 ">
                      <strong> Signature:</strong>
                    </label>
                    <ckeditor [(ngModel)]="selectedStaff.signerMail"  [config]="CkeditorConfig" *ngIf="isEdit" debounce="300">
  
              
                    </ckeditor>
            
                    <ckeditor [(ngModel)]="selectedStaff.signerMail"  [config]="CkeditorConfig1"  [readonly]="true" *ngIf="!isEdit" debounce="300">
  
              
                      </ckeditor>
                    <br />
                </div>
            </div>



          </div>
        </div>

      </div>
    </div>


  </div>

</div>